import { useState } from "react";
import { useApp } from "../context/AppContext";
import TicketsView from "./TicketsView";
import MyTicketsView from "./MyTicketsView";

const TABS = [
  { key: "project", label: "Проектні" },
  { key: "my", label: "Мої тікети" },
];

export default function TicketsCombinedView() {
  const { dark, t, activeId } = useApp();
  const [tab, setTab] = useState(activeId ? "project" : "my");

  return (
    <div>
      <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
        {TABS.map(tb => (
          <button key={tb.key} onClick={() => setTab(tb.key)} style={{
            padding: "8px 20px", borderRadius: 8, border: "none", cursor: "pointer",
            background: tab === tb.key ? "#6366f1" : dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
            color: tab === tb.key ? "#fff" : t.text,
            fontWeight: tab === tb.key ? 700 : 500, fontSize: 13, fontFamily: "inherit",
            transition: "all .15s",
          }}>
            {tb.label}
          </button>
        ))}
      </div>
      {tab === "project" && <TicketsView />}
      {tab === "my" && <MyTicketsView />}
    </div>
  );
}
